var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-card',{attrs:{"title":_vm.$t ('regStats.title')}},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('name-value-block',{attrs:{"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }